import SectionInfoBox from '../../../components/SectionInfoBox';

interface KeyHighlightsProps {
    highlights?: { icon: string; text: string }[];
    sectionInfo?: any;
    getImageUrl?: (url: string) => string;
}

const KeyHighlights: React.FC<KeyHighlightsProps> = ({ highlights, sectionInfo, getImageUrl }) => {
    const displayHighlights = (highlights && highlights.length > 0) ? highlights : [
        { icon: 'fa-location-dot', text: 'Prime Location' },
        { icon: 'fa-city', text: 'Premium Residences' },
        { icon: 'fa-leaf', text: '65% Open Space' },
        { icon: 'fa-swimming-pool', text: '25+ Amenities' },
        { icon: 'fa-shield-halved', text: '24x7 Security' },
        { icon: 'fa-car', text: 'Basement Parking' }
    ];

    return (
        <div id="key-highlights" className="card border border-gray-200 shadow-sm rounded-2xl mb-4 overflow-hidden scroll-mt-32">
            <div className="bg-white py-2.5 px-6 md:px-8 border-b border-gray-100 flex items-center gap-2">
                <h4 className="text-xl md:text-2xl font-black bg-clip-text text-transparent bg-gradient-to-r from-[#05144b] to-[#4c1d95] leading-tight">Key Highlights</h4>
                <SectionInfoBox text={sectionInfo?.highlights} />
            </div>
            <div className="p-4 md:p-6">
                <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-2.5 md:gap-4">
                    {displayHighlights.map((item, idx) => (
                        <div key={idx} className="bg-white p-2.5 md:p-3 rounded-xl border border-gray-100 shadow-sm flex items-center gap-3 md:gap-4 hover:shadow-lg hover:-translate-y-0.5 transition-all duration-300 group">
                            <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-slate-50 flex items-center justify-center transition-transform group-hover:scale-105 shrink-0 shadow-sm border border-gray-100 overflow-hidden p-1.5">
                                {item.icon && !item.icon.startsWith('fa-') && getImageUrl ? (
                                    <img 
                                        src={getImageUrl(item.icon)} 
                                        alt={item.text} 
                                        className="w-full h-full object-contain"
                                        onError={(e) => {
                                            const target = e.target as HTMLImageElement;
                                            target.style.display = 'none';
                                            target.parentElement?.insertAdjacentHTML('beforeend', `<i class="fa-solid fa-star text-[#05144b] text-lg md:text-xl"></i>`);
                                        }}
                                    />
                                ) : (
                                    <i className={`fa-solid ${item.icon || 'fa-star'} text-[#05144b] text-lg md:text-xl`}></i>
                                )}
                            </div>
                            <div className="min-w-0 flex-1">
                                <p className="text-[13px] md:text-[15px] font-bold text-[#05144b] leading-tight whitespace-nowrap truncate">{item.text}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default KeyHighlights;
